import { render, staticRenderFns } from "./nested-draggable.vue?vue&type=template&id=e40ee058&scoped=true&"
import script from "./nested-draggable.vue?vue&type=script&lang=js&"
export * from "./nested-draggable.vue?vue&type=script&lang=js&"
import style0 from "./nested-draggable.vue?vue&type=style&index=0&id=e40ee058&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e40ee058",
  null
  
)

export default component.exports